import { connect } from "react-redux"
import SignupForm from "../index"
import { Dispatch } from "@redux/store"

const mapDispatch = (dispatch: Dispatch) => ({
  onSubmit: dispatch.customer.createAccount,
})

export default connect(undefined, mapDispatch)(SignupForm)
